<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="abb"><a id="page_xiv"></a><a id="page_xv"></a><a href="#/xhtml/contents#abb">Abbreviations</a></p>
<table cellpadding="0" cellspacing="0" class="abbre">
<tbody><tr>
<td>AB</td>
<td>Anchor Bible</td>
</tr>
<tr>
<td>ABNTC</td>
<td>Abingdon New Testament Commentaries</td>
</tr>
<tr>
<td><i>ABR</i></td>
<td><i>Australian Biblical Review</i></td>
</tr>
<tr>
<td>ACCS NT</td>
<td>Ancient Christian Commentary on Scripture: New Testament</td>
</tr>
<tr>
<td><i>AUSS</i></td>
<td><i>Andrews University Seminary Studies</i></td>
</tr>
<tr>
<td>BAGD</td>
<td>Bauer, Walter, William F. Arndt, F. Wilbur Gingrich, and Frederick W. Danker. <i>Greek-English Lexicon of the New Testament and Other Early Christian Literature</i>. 2nd ed. Chicago: University of Chicago Press, 1979</td>
</tr>
<tr>
<td>BDAG</td>
<td>Danker, Frederick W., Walter Bauer, William F. Arndt, and F. Wilbur Gingrich. <i>Greek-English Lexicon of the New Testament and Other Early Christian Literature</i>. 3rd ed. Chicago: University of Chicago Press, 2000</td>
</tr>
<tr>
<td>BECNT</td>
<td>Baker Exegetical Commentary on the New Testament</td>
</tr>
<tr>
<td><i>Bib</i></td>
<td><i>Biblica</i></td>
</tr>
<tr>
<td><i>BibNotiz</i></td>
<td><i>Biblische Notizen</i></td>
</tr>
<tr>
<td><i>BJRL</i></td>
<td><i>Bulletin of the John Rylands University Library of Manchester</i></td>
</tr>
<tr>
<td><i>BSac</i></td>
<td><i>Bibliotheca Sacra</i></td>
</tr>
<tr>
<td><i>BT</i></td>
<td><i>The Bible Translator</i></td>
</tr>
<tr>
<td><i>BTB</i></td>
<td><i>Biblical Theology Bulletin</i></td>
</tr>
<tr>
<td><i>BZ</i></td>
<td><i>Biblische Zeitschrift</i></td>
</tr>
<tr>
<td><i>CBQ</i></td>
<td><i>Catholic Biblical Quarterly</i></td>
</tr>
<tr>
<td>EKKNT</td>
<td>Evangelisch-katholischer Kommentar zum Neuen Testament</td>
</tr>
<tr>
<td><i>EvQ</i></td>
<td><i>Evangelical Quarterly</i></td>
</tr>
<tr>
<td><i>ExpTim</i></td>
<td><i>Expository Times</i></td>
</tr>
<tr>
<td><i>Int</i></td>
<td><i>Interpretation</i></td>
</tr>
<tr>
<td>IVPNTCS</td>
<td>The IVP New Testament Commentary Series</td>
</tr>
<tr>
<td><i>JBL</i></td>
<td><i>Journal of Biblical Literature</i></td>
</tr>
<tr>
<td><i>JETS</i></td>
<td><i>Journal of the Evangelical Theological Society</i></td>
</tr>
<tr>
<td><i>JSNT</i></td>
<td><i>Journal for the Study of the New Testament</i></td>
</tr>
<tr>
<td>JSNTSup</td>
<td>Journal for the Study of the New Testament Supplement Series</td>
</tr>
<tr>
<td><i>JTS</i></td>
<td><i>Journal of Theological Studies</i></td>
</tr>
<tr>
<td><a id="page_xvi">MM</a></td>
<td>Moulton, J. H., and G. Milligan. <i>The Vocabulary of the Greek Testament.</i> London, 1930. Reprint, Peabody, MA: Hendrickson, 1997</td>
</tr>
<tr>
<td>NAC</td>
<td>New American Commentary</td>
</tr>
<tr>
<td><i>Neot</i></td>
<td><i>Neotestamentica</i></td>
</tr>
<tr>
<td>NICNT</td>
<td>New International Commentary on the New Testament</td>
</tr>
<tr>
<td>NIV</td>
<td>New International Version</td>
</tr>
<tr>
<td><i>NotesTrans</i></td>
<td><i>Notes on Translation</i></td>
</tr>
<tr>
<td><i>NovT</i></td>
<td><i>Novum Testamentum</i></td>
</tr>
<tr>
<td>NRSV</td>
<td>New Revised Standard Version</td>
</tr>
<tr>
<td><i>NTS</i></td>
<td><i>New Testament Studies</i></td>
</tr>
<tr>
<td><i>OTP</i></td>
<td>Charlesworth, J. H., ed. <i>Old Testament Pseudepigrapha.</i> 2 vols. New York: Doubleday, 1983, 1985</td>
</tr>
<tr>
<td>PCNT</td>
<td>Paideia Commentaries on the New Testament</td>
</tr>
<tr>
<td><i>RB</i></td>
<td><i>Revue biblique</i></td>
</tr>
<tr>
<td>REB</td>
<td>Revised English Bible</td>
</tr>
<tr>
<td><i>ResQ</i></td>
<td><i>Restoration Quarterly</i></td>
</tr>
<tr>
<td><i>RevExp</i></td>
<td><i>Review and Expositor</i></td>
</tr>
<tr>
<td><i>RevScRel</i></td>
<td><i>Revue des sciences religieuses</i></td>
</tr>
<tr>
<td><i>RTR</i></td>
<td><i>Reformed Theological Review</i></td>
</tr>
<tr>
<td>SBL</td>
<td>Society of Biblical Literature</td>
</tr>
<tr>
<td>SBLDS</td>
<td>SBL Dissertation Series</td>
</tr>
<tr>
<td><i>SJT</i></td>
<td><i>Scottish Journal of Theology</i></td>
</tr>
<tr>
<td>SNTSMS</td>
<td>Society for New Testament Studies Monograph Series</td>
</tr>
<tr>
<td>TU</td>
<td>Texte und Untersuchungen</td>
</tr>
<tr>
<td><i>TynBul</i></td>
<td><i>Tyndale Bulletin</i></td>
</tr>
<tr>
<td><i>TZ</i></td>
<td><i>Theologische Zeitschrift</i></td>
</tr>
<tr>
<td>WBC</td>
<td>Word Biblical Commentary</td>
</tr>
<tr>
<td><i>WTJ</i></td>
<td><i>Westminster Theological Journal</i></td>
</tr>
<tr>
<td>ZECNT</td>
<td>Zondervan Exegetical Commentary on the New Testament</td>
</tr>
<tr>
<td><i>ZNW</i></td>
<td><i>Zeitschrift für die neutestamentliche Wissenschaft</i></td>
</tr>
<tr>
<td><i>ZTK</i></td>
<td><i>Zeitschrift für Theologie und Kirche</i></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?f20589e0